import Select, { SelectOption } from '@bugbug/core/components/Select';
import styled from 'styled-components';

export const LargeContainer = styled(Select)`
  button {
    min-height: 44px !important;
    border-radius: 8px;
  }

  span {
    line-height: 24px;
  }
`;

export const Option = styled(SelectOption)`
  span {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;
Option.displayName = 'SelectOption'; // Required by Select.jsx lol

export const OptionPrice = styled.span`
  font-size: 12px;
  color: ${(props) => props.theme.colors.text.secondary};
  margin-left: auto;
`;
